import queryString from "query-string";
import {
  setStoreItemsCopy,
  updateStoreItemCopy,
  removeStoreItemCopy,
  addStoreCopy,
} from "./appifyActions";
import { privateFetch } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

export const setWebStore = (options, storeItems) => ({
  type: "SET_WEB_STORE",
  options,
  storeItems,
});
